// extracted by mini-css-extract-plugin
export default {"mySelect":"MySelect_mySelect__xd5b8"};